import React from 'react';
import { NavLink } from 'react-router-dom';

const CoverLetter = () => {
    return (
        <div className='home h-full px-5 py-[50px] md:py-[100px] md:px-0 bg-custom-background'>
            <div className='h-full grid lg:grid-rows-[min_content_min_content] gap-8 md:px-[80px] text-charcoal bg-custom-background'>
                <div className='grid gap-5 md:gap-10 lg:grid-cols-[1fr_1fr] items-center pb-10 border-2 border-b-black'>
                    <div className='grid gap-2'>
                        <p className='text-[15vw] md:text-[4vw] leading-[1em] font-grandslang'>
                            Daverose Tholley
                        </p>
                        <p className='uppercase text-[16px] md:text-[18px] font-[550] text-charcoal tracking-[2px]'>
                            Frontend Engineer
                        </p>
                        <p className='text-[14px] md:text-[16px] font-[450] leading-[1.9em] tracking-[.5px]'>
                            <NavLink 
                                to='https://daverosetholley.com' 
                                className='underline-slide white'
                                aria-label='Visit my portfolio website'
                            >
                                daverosetholley.com
                            </NavLink>
                            {' | '}
                            <NavLink 
                                className='underline-slide white' 
                                to="mailto:info@daverosetholley.com?subject=Interested%20in%20your%20frontend%20engineering%20services&body=Hi%20Daverose,%0D%0A%0D%0AI%20hope%20you're%20doing%20well!%0D%0A%0D%0AI'm%20reaching%20out%20because%20I'm%20curious%20about%20your%20frontend%20engineering%20services%20and%20how%20they%20could%20fit%20with%20my%20project.%20Would%20you%20be%20available%20for%20a%20quick%20chat%20to%20discuss%20further%3F%0D%0A%0D%0AThanks%20in%20advance!"
                                aria-label='Email me'
                            >
                                info@daverosetholley.com
                            </NavLink>
                        </p>
                    </div>
                    <div className='w-fit'>
                        <p className='font-grandslang text-[16px] md:text-[1.4vw] leading-[1.9em] font-[600]'>
                           I'm a frontend engineer who loves turning code into smooth, easy-to-use web apps. I’m experienced with React, Next.js, and TypeScript, and I’m all about making sure everything looks great and runs fast. I like solving problems and making sure users don’t have to wait—because who wants a slow site? I’m not promising miracles, but I’ll definitely bring my A-game to ensure things work like they’re supposed to.
                        </p>
                    </div>
                </div>
                <address className='w-fit relative left-[80%] font-semi-bold text-l'>
                    <p>
                        <strong>Daverose Tholley</strong>
                        <br />
                        K829 Ransford Kotey Avenue
                        <br />
                        Accra, Greater Accra
                        <br />
                        Ghana
                    </p>
                </address>
                <div className='grid gap-4 font-medium text-l'>
                    <p className='font-semi-bold'>
                        <strong>Hiring Team</strong><br />
                        VAPA GmbH.<br />
                        Im Media Park 550670,<br />
                        Cologne,<br />
                        Germany<br />
                    </p>
                     
                    <br/>
                    <p>Dear Hiring Team,</p>
                    <br/>
                    <p>
                        I’m excited to be applying for the Frontend Engineer position at VAPA GmbH. I have to say, your AI-powered marketing automation has all the right ingredients to make things seriously cool—and who doesn’t want to be part of a team that’s helping brands stop guessing and start knowing? Honestly, if I had a nickel for every time a marketing team had to pivot because of inaccurate data, I’d be a rich frontend engineer by now. I'm not going to pretend I know all the details about marketing, but I do know that data and optimization make everything better, and it’s clear that VAPA gets that. 
                    </p>
                    <p>
                        In my role at Enyata Ghana, I’ve been working with tools like React, Next.js, and TypeScript to build scalable, performance-optimized web apps. One of my favorite things about the work I do is trying to find that sweet spot between clean, responsive designs and performance, because—let’s be honest—no one likes a website that’s slow to load. I’ve spent a lot of time digging into performance bottlenecks, and building out solutions that make the user experience as smooth as possible. I’m confident this focus on speed and efficiency would fit well with your goal of delivering real-time, AI-driven marketing insights to clients.
                    </p>
                    <p>
                        Also, on a personal note: I’ve worked on projects that required multicultural collaboration, so I’m no stranger to remote teams or diverse perspectives. Whether it's working with a team across different time zones or figuring out the best way to break down a problem, I enjoy the process of collaborating and learning from others—and I believe that’s how great products are built.
                    </p>
                    <p>
                        I’m really looking forward to the possibility of joining your team and working on something that makes marketing a bit more effective and a little less overwhelming. If we can make marketing automation feel as smooth as using a favorite app (you know, the one you actually enjoy using), I think we’re on to something.
                    </p>
                    <p>
                        Thanks for considering my application. I’m excited about the chance to discuss how I can help make VAPA’s platform even better.
                    </p>
                   <p>
                        Sincerely,<br />
                        Daverose Tholley
                    </p>
                </div>
            </div>
        </div>
    );
};

export { CoverLetter };
